var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visualizationBOx"},[_c('div',{attrs:{"id":"visualization"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model),expression:"model"}],staticClass:"model",staticStyle:{"justify-content":"center"}},[_c('p',[_vm._v(_vm._s(_vm.model_title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('invite_code'))+": "+_vm._s(_vm.model_code))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e13b688","hasScoped":false,"transformToRequire":{"vue-h-zoom":["image","image-full"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vis.vue
// module id = null
// module chunks = 